import React from 'react'
import PropTypes from 'prop-types'

import Tooltip from '../../UI/Tooltip/Tooltip'
import generateTooltip from '../../../Util/decodeTag'



const tableCell = (props) => {
  let cellValue = <span>{props.val}</span>;

  if (props.type==='mark') {
    const tooltipText = generateTooltip(props.val)
    cellValue = <Tooltip text={tooltipText} >{props.val}</Tooltip>

  }

  return (
    <td className="TableCell">
      {cellValue}
    </td>
  )

}

tableCell.propTypes = {
  onHover: PropTypes.func,
  type: PropTypes.oneOf([
    'ordflokkur',
    'fjoldi',
    'mark',
    'rodun',
    'ordmynd',
    'fjolditexta',
    'rodun_an_p',
    'lemma'
  ]).isRequired
}

export default tableCell;



// WEBPACK FOOTER //
// ./src/Components/Table/TableCell/TableCell.js